import React from 'react';
import { FaTimes } from "react-icons/fa";
import './pagetitle.css';

const PageTitle = ({ title, onClick, address, phone }) => {
  return (
    <div className='d-flex flex-column p-3 title-bg'>
      {/* Title */}
      <div className='bold text-white mb-0.5' style={{ color: "#FFD700", fontSize: "1.2rem" }}>
        {title}
      </div>

      {/* Address */}
      <div className='regular text-white-50 mb-0.5' style={{ fontSize: "0.9rem" }}>
        {address}
      </div>

      {/* Phone Number */}
      {phone && (
      <div className='regular text-white-50 mb-0.5' style={{ fontSize: "0.9rem" }}>
        Phone No: {phone}
      </div>
      )}

      {/* Close Button */}
      <div className='align-self-end'>
        <button
          onClick={onClick}
          className="btn btn-sm p-1 border-0"
          style={{ color: "#FFD700", fontSize: "1.2rem", background: "none" }}
          aria-label="Close"
        >
          <FaTimes />
        </button>
      </div>
    </div>
  );
}

export default PageTitle;
